import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';

const DEFAULT_MOVE_DATA = {
  start_date: '',
  day_of_week: '1' // Monday
};

const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const BulkMoveScheduleDatesModal = ({ isOpen, toggle, onSave, disabled }) => {
  const [moveData, setMoveData] = useState(DEFAULT_MOVE_DATA);

  useEffect(() => {
    if (!isOpen) {
      setMoveData(DEFAULT_MOVE_DATA);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMoveData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onSave(moveData);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Bulk Move Dates</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="start_date">New Start Date *</Label>
          <Input
            type="date"
            id="start_date"
            name="start_date"
            value={moveData.start_date}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label for="day_of_week">Day of Week *</Label>
          <Input
            type="select"
            id="day_of_week"
            name="day_of_week"
            value={moveData.day_of_week}
            onChange={handleChange}
          >
            <option value="0">Sunday</option>
            <option value="1">Monday</option>
            <option value="2">Tuesday</option>
            <option value="3">Wednesday</option>
            <option value="4">Thursday</option>
            <option value="5">Friday</option>
            <option value="6">Saturday</option>
          </Input>
          <small className="text-muted">
            The first schedule date will move to the first {dayNames[parseInt(moveData.day_of_week, 10)]} on or after the selected start date.
          </small>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSave}
          disabled={disabled || !moveData.start_date}
        >
          Move Dates
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BulkMoveScheduleDatesModal;
